<template>
  <div>
    <!-- 설문조사 Creator dialog -->
    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card>
        <div class="dialog-container" style="width: 100%;">
          <div class="dialog-header">
            <h1 class="header-title">결과</h1>
          </div>
        <div style="padding: 10px;" v-if="surveyResult.replySurvey">
          <div>
            <span style="font-weight: bold; font-size: 18px; color: #111; margin-left: 10px;">제목 - {{ surveyResult.title }}</span>
            <span style="font-weight: normal; font-size: 16px; color: #555;">(총 응답 {{ surveyResult.replySurvey.length }}개)</span>
          </div>
          <div>
            <div v-for="(question, index) in surveyResult.questions" :key="question.question" class="surveyQ">
              <div style="margin-bottom: 20px;">
                질문 : {{ question.question }} <span style="font-weight: bold;">({{ question.type === 'text' ? '서술형' : question.type === 'radio' ? '단일선택' : '다중선택' }})</span>
              </div>
              <div v-if="question.type === 'radio'" v-html="singleChoiceHtml"></div>
              <div v-if="question.type === 'check'" v-html="multiChoiceHtml"></div>
              <div v-for="answer in surveyResult.replySurvey" :key="answer._id" style="margin-bottom: 8px;">
                <div v-if="question.type === 'text'">
                  - {{ answer.answers[index] }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <v-card-actions>
          <v-spacer></v-spacer>
          <button class="noIconButton" @click="cancel">닫기</button>
        </v-card-actions>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import EChart from '@/components/chart/echart';

export default {
  filters: {
    reSurveyResultData: function (answer) {
      return { 'name': answer, 'value': answer };
    },
  },
  components: {
    EChart
  },
  props: {
    dialog: { type: Boolean, default: false },
    surveyResult: {},
    close: { type: Function },
  },
  data () {
    return {
      e1: 1,
      steps: 1,
      totalScore: 0,
      singleChoiceHtml: '',
      multiChoiceHtml: '',
      survey: {
        title: '',
        creator: this.$store.state.user,
        questions: [
          {
            number: 1,
            question: '',
            type: 'text',
            items: [],
            answer: null
          }
        ],
      },
      newProperty: null,
      defaultQuestion: {
        number: 1,
        question: '',
        type: 'text',
        items: [],
        answer: null
      },
      resultData: [
   
      ],
      surveyItems: [
        { text: '서술형', value: 'text' },
        { text: '단일 선택', value: 'radio' },
        { text: '다중 선택', value: 'check' }
      ],
      colorDefined: {
        room: '#464775',
        video: '#464775',
        roomVideo: '#464775'
      },
      deleteProperties: null,
    };
  },
  watch: {
    dialog: {
      handler (val) {
        if (val) {
          this.getChartData();
          this.showResult();
        }
      }
    }
  },
  methods: {
    showResult () {
      let radioArray = [];
      let multiArray = [];

      this.surveyResult.questions.forEach((el, index) => {
        if (el.type === 'check') {
          this.surveyResult.replySurvey.forEach((item, num) => {
            if (this.surveyResult.replySurvey.length === num + 1) {
              multiArray.push(item.answers[index]);
              this.renderMultiChoiceResult(multiArray);
            } else {
              multiArray.push(item.answers[index]);
            }
          });
        } else if (el.type === 'radio') {
          this.surveyResult.replySurvey.forEach((item, num) => {
            if (this.surveyResult.replySurvey.length === num + 1) {
              radioArray.push(item.answers[index]);
              this.renderSingleChoiceResult(radioArray);
            } else {
              radioArray.push(item.answers[index]);
            }
          });
        }
      });
      // renderMultiChoiceResult(this.surveyResult.replySurvey);
    },
    getChartData (index) {
      let resultArr = [];
      let chartArr = [];
      let resultScore = 0;
      for (let i = 0; i < this.surveyResult.questions.length; i++) {
        for (let j = 0; j < this.surveyResult.replySurvey.length; j++) {
          if (this.surveyResult.questions[i].type === 'text') {
            // console.log(`text : `, this.surveyResult.replySurvey[j].answers[i]);
          } else {
            let resultObj = { 'value': this.surveyResult.replySurvey[j].answers[i] };
            resultArr.push(this.surveyResult.replySurvey[j].answers[i]);
            
            if (this.surveyResult.replySurvey[j].answers[i] === '매우 그렇다') {
              resultScore += 100;
            } else if (this.surveyResult.replySurvey[j].answers[i] === '그렇다') {
              resultScore += 80;
            } else if (this.surveyResult.replySurvey[j].answers[i] === '보통이다') {
              resultScore += 60;
            } else if (this.surveyResult.replySurvey[j].answers[i] === '아니다') {
              resultScore += 40;
            } else {
              resultScore += 20;
            }
          }
        }
      }

      this.totalScore = Math.ceil(resultScore / resultArr.length);
      // 중복된 값을 count로 합치기
      const result = resultArr.reduce((accu, curr) => { 
        accu[curr] = (accu[curr] || 0) + 1;
        return accu;
      }, {});

      // reduce로 나온 값을 key value로 나누기
      
      for (let [key, value] of Object.entries(result)) {
        this.resultData.push({ 'name': key, 'value': value });
      }

    },
    getKeyIndex (arr, obj) {
      for (let i = 0; i < arr.length; i++) {
        if (arr[i].value === obj.index) {
          return i;
        }
      }
      return -1;
    },
    cancel () {
      this.close('cancel');
    },
    renderSingleChoiceResult (data) {
      const total = data.length;
      const counts = {};

      data.forEach(item => {
        let answer = item;
        counts[answer] = (counts[answer] || 0) + 1; 
      });
      let text = '';
      Object.entries(counts).forEach(([key, count]) => {
        const percent = ((count / total) * 100).toFixed(0);
        text += `<div style="margin-bottom: 8px;">${key} (${percent}%)</div>`;
      });
      this.singleChoiceHtml = text;
    },
    renderMultiChoiceResult (data) {
      console.log(data)
      const optionCount = {};
      let totalAnswers = 0;

      data.forEach(item => {
        let answers = item;
        answers.forEach(ans => {
          optionCount[ans] = (optionCount[ans] || 0) + 1;
          totalAnswers++;
        });
      });

      let text = '';
      Object.entries(optionCount).forEach(([key, count]) => {
        const percent = ((count / totalAnswers) * 100).toFixed(0);
        text += `<div style="margin-bottom: 8px;">${key} (${percent}%)</div>`;
      });

      this.multiChoiceHtml = text;
    },
  }
};
</script>

<style scoped>
.surveyQ {
  overflow-y: auto;
  height: auto;
  padding: 15px 20px;
  margin: 0 10px;
  margin-top: 10px;
  border-radius: 8px;
  border: 1px solid #ccc;
}

.surveyQ:first-child {
  margin-top: 15px;
}
.header-title {
  color: white;
  font-size: 18px;
  padding-left: 20px;
}

.dialog-header { 
  height: 50px;
  background-color: #23408e;
}
</style>


// WEBPACK FOOTER //
// src/components/popup/KsdSurveyResult.vue